import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { makeStyles, TextField } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';

import CardHeader from '../../components/Card/CardHeader';
import {
  createPinCode,
  deletePincode,
  getAllPinCode,
  unPublishPincode,
  updatePincodeDetails
} from '../../store/actions/admin/Admin';
import CustomInputWithIcons from '../../components/CustomInput/CustomInputWithIcons.js';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

const useStyles = makeStyles((theme) => ({
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  },
  editPostalCode: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '75%'
  }
}));

const PostalCode = ({
  pinCodes,
  getAllPinCode,
  createPinCode,
  updatePincodeDetails,
  deletePincode,
  unPublishPincode,
  pinCodesCount
}) => {
  const classes = useStyles();
  const [pageNo, updatePageNo] = useState(1)
  const [isEdit, updateEdit] = useState(false);
  const [addNew, updateAddNew] = useState(false);
  const [pincode, updatePincode] = useState();
  const [pincodeName, updatePincodeName] = useState();
  const [editDetail, updateEditDetail] = useState({});

  useEffect(() => {
    getAllPinCode(pageNo);
  }, []);

  const addNewPinCode = () => {
    updateAddNew(true);
  };

  const updatePinCode = (e) => {
    if (e.target.value) {
      updatePincode(e.target.value);
    }
  };

  const updatePinCodeName = (e) => {
    if (e.target.value) {
      updatePincodeName(e.target.value);
    }
  };

  const addNewPostalCode = () => {
    const payload = {
      pincode: pincode,
      pincodeName: pincodeName
    };
    createPinCode(payload).then((data) => {
      updateAddNew(false);
      getAllPinCode(pageNo);
    });
  };

  const editPostalCode = (index) => {
    updateEdit(true);
    updateEditDetail({
      pincodeId: pinCodes[index].id,
      pincode: pinCodes[index].pincode,
      pincodeName: pinCodes[index].pincodeName
    });
  };

  const updateEditPincode = (e) => {
    updateEditDetail({
      ...editDetail,
      pincode: e.target.value
    });
  };

  const updateEditPincodeName = (e) => {
    updateEditDetail({
      ...editDetail,
      pincodeName: e.target.value
    });
  };

  const cancelEditPincode = () => {
    updateEdit(false);
    updateEditDetail({});
  };

  const updatePinCodeDetail = () => {
    updatePincodeDetails(editDetail).then((data) => {
      updateEdit(false);
      getAllPinCode(pageNo);
    });
  };

  const deletePostalCode = (index) => {
    deletePincode(pinCodes[index].id).then((data) => {
      getAllPinCode(pageNo);
    });
  };

  const handlePagination = (e, page) => {
    updatePageNo(page)
    getAllPinCode(page);
  }

  const unPublish = (index) => {
    const payload = {
      pincodeId: pinCodes[index].id,
      status: !pinCodes[index].active
    };
    unPublishPincode(payload).then((data) => {
      if (data) {
        getAllPinCode(pageNo);
      }
    });
  };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All Postal Code - Add, Update, Delete
        </h4>
        <p className={classes.cardCategoryWhite}>
          PNG Images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Postal Code</th>
            <th>Postal Name</th>
            <th>Update</th>
            <th>Publish / Unpublish</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {pinCodes.length ? (
            pinCodes.map((item, index) => (
              <tr>
                <th scope="row">{index + 1}</th>
                <td style={{ display: 'flex', justifyContent: 'center' }}>
                  {isEdit && editDetail?.pincodeId === item.id ? (
                    <div className={classes.editPostalCode}>
                      <TextField
                        label="Postal Code"
                        name="postalCode"
                        id="postalCode"
                        value={editDetail.pincode}
                        onChange={updateEditPincode}
                      />
                    </div>
                  ) : (
                      item.pincode
                    )}
                </td>
                <td>
                  {isEdit && editDetail?.pincodeId === item.id ? (
                    <div className={classes.editPostalCode}>
                      <TextField
                        label="Postal Code Name"
                        name="postalCodeName"
                        id="postalCodeName"
                        value={editDetail.pincodeName}
                        onChange={updateEditPincodeName}
                      />
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          width: '50%'
                        }}
                      >
                        <Button color="primary" onClick={updatePinCodeDetail}>
                          Update
                        </Button>
                        <Button color="secondary" onClick={cancelEditPincode}>
                          Cancel
                        </Button>
                      </div>
                    </div>
                  ) : (
                      item.pincodeName
                    )}
                </td>
                <td>
                  <EditIcon onClick={() => editPostalCode(index)} />
                </td>
                <td>
                  <Button onClick={() => unPublish(index)}>
                    {pinCodes[index].active ? 'Unpublish' : 'Publish'}
                  </Button>
                </td>
                <td>
                  <DeleteIcon onClick={() => deletePostalCode(index)} />
                </td>
              </tr>
            ))
          ) : (
              <tr>
                <td>No data yet..</td>
                <td>No data yet..</td>
                <td>No data yet..</td>
                <td>No data yet..</td>
                <td>No data yet..</td>
              </tr>
            )}
        </tbody>
      </Table>
      <Pagination
        count={pinCodesCount ? Math.ceil(pinCodesCount / 10) : 1}
        color="primary"
        page={pageNo}
        onChange={handlePagination}
      />
      <Modal isOpen={addNew} toggle={() => updateAddNew(!addNew)}>
        <ModalHeader toggle={() => updateAddNew(!addNew)}>
          Add New Postal Code
        </ModalHeader>
        <ModalBody>
          <div>
            <CustomInputWithIcons
              labelText="Postal Code"
              name="postalCode"
              id="postalCode"
              value={pincode}
              onChange={updatePinCode}
              formControlProps={{
                fullWidth: true
              }}
            />
          </div>
          <div>
            <CustomInputWithIcons
              labelText="Postal Name"
              name="postalName"
              id="postalName"
              value={pincodeName}
              onChange={updatePinCodeName}
              formControlProps={{
                fullWidth: true
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={addNewPostalCode}>
            Add
          </Button>
        </ModalFooter>
      </Modal>
      <Link>
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
          onClick={addNewPinCode}
          href="//#endregion"
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ fontWeight: 600, marginTop: '22px' }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
};

const mapStateWithProps = (state) => ({
  pinCodes: state.admin.pinCodes,
  pinCodesCount: state.admin.pinCodesCount
});

const mapDispatchWithProps = (dispatch) => {
  return {
    createPinCode: (data) => dispatch(createPinCode(data)),
    getAllPinCode: (pageNo) => dispatch(getAllPinCode(pageNo)),
    updatePincodeDetails: (data) => dispatch(updatePincodeDetails(data)),
    deletePincode: (id) => dispatch(deletePincode(id)),
    unPublishPincode: (data) => dispatch(unPublishPincode(data))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(PostalCode);
